import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';

const inputClass =
  'w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition focus:border-[#0075ca] focus:ring-4 focus:ring-[#0075ca]/15 sm:text-base';

const productLabels = {
  Carpet: 'Carpet',
  CarpetTile: 'Carpet Tile',
  Laminate: 'Laminate',
  LuxuryVinyl: 'Luxury Vinyl',
  Tile: 'Tile',
  Vinyl: 'Vinyl',
  Waterproof: 'Waterproof',
  Cork: 'Cork',
  AreaRugs: 'Area Rugs',
  HardWood: 'Hardwood',
};

function RequestEstimate() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    date: null,
    products: {
      Carpet: false,
      CarpetTile: false,
      Laminate: false,
      LuxuryVinyl: false,
      Tile: false,
      Vinyl: false,
      Waterproof: false,
      Cork: false,
      AreaRugs: false,
      HardWood: false,
    },
    comment: '',
    keepMeUpdated: false,
  });

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prev) => ({ ...prev, date }));
  };

  const handleCheckboxChange = (checkboxName) => {
    setFormData((prev) => ({
      ...prev,
      products: {
        ...prev.products,
        [checkboxName]: !prev.products[checkboxName],
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formresponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/form`,
        formData
      );
      alert(formresponse.data.data1);
      window.location.reload();
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <section className="bg-[#f7f8fa] py-12 sm:py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0075ca] sm:text-xs">
            Free consultation
          </p>
          <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
            Request an estimate
          </h2>
          <p className="mt-2 text-sm text-slate-500 sm:text-base">
            Meet with one of our skilled project specialists to get started
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="mt-8 rounded-[1.75rem] bg-white p-5 shadow-sm ring-1 ring-slate-200/80 sm:mt-10 sm:p-8 md:p-10"
        >
          <div className="grid gap-4 sm:grid-cols-2">
            <input
              type="text"
              className={inputClass}
              placeholder="First name"
              value={formData.firstName}
              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
              required
            />
            <input
              type="text"
              className={inputClass}
              placeholder="Last name"
              value={formData.lastName}
              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
              required
            />
          </div>

          <div className="mt-4 grid gap-4">
            <input
              type="text"
              className={inputClass}
              placeholder="Phone"
              maxLength={10}
              value={formData.phoneNumber}
              onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
              required
            />
            <input
              type="email"
              className={inputClass}
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
            <input
              type="text"
              className={inputClass}
              placeholder="Street address"
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              required
            />
          </div>

          <div className="mt-4 grid gap-4 sm:grid-cols-6">
            <input
              type="text"
              className={`${inputClass} sm:col-span-3`}
              placeholder="City"
              value={formData.city}
              onChange={(e) => setFormData({ ...formData, city: e.target.value })}
              required
            />
            <input
              type="text"
              className={`${inputClass} sm:col-span-2`}
              placeholder="State"
              value={formData.state}
              onChange={(e) => setFormData({ ...formData, state: e.target.value })}
              required
            />
            <input
              type="text"
              className={`${inputClass} sm:col-span-1`}
              placeholder="Zip"
              value={formData.zip}
              onChange={(e) => setFormData({ ...formData, zip: e.target.value })}
              required
            />
          </div>

          <div className="mt-4">
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              placeholderText="Select a date"
              className={inputClass}
              dateFormat="MM/dd/yyyy"
              isClearable
              wrapperClassName="w-full"
            />
          </div>

          <fieldset className="mt-6">
            <legend className="text-sm font-semibold text-slate-800 sm:text-base">
              What products are you interested in?
            </legend>
            <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3">
              {Object.keys(formData.products).map((productName) => (
                <label
                  key={productName}
                  className={`flex cursor-pointer items-center gap-2 rounded-xl border px-3 py-2.5 text-xs sm:text-sm ${
                    formData.products[productName]
                      ? 'border-[#0075ca] bg-[#0075ca]/5 text-[#0075ca]'
                      : 'border-slate-200 text-slate-700 hover:border-slate-300'
                  }`}
                >
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-slate-300 text-[#0075ca] focus:ring-[#0075ca]"
                    checked={formData.products[productName]}
                    onChange={() => handleCheckboxChange(productName)}
                  />
                  {productLabels[productName] || productName}
                </label>
              ))}
            </div>
          </fieldset>

          <div className="mt-4">
            <textarea
              className={`${inputClass} min-h-[96px] resize-y`}
              placeholder="Comment"
              value={formData.comment}
              onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
              required
            />
          </div>

          <label className="mt-4 flex items-start gap-2 text-xs text-slate-600 sm:text-sm">
            <input
              type="checkbox"
              className="mt-0.5 h-4 w-4 rounded border-slate-300 text-[#0075ca] focus:ring-[#0075ca]"
              checked={formData.keepMeUpdated}
              onChange={() =>
                setFormData((prev) => ({
                  ...prev,
                  keepMeUpdated: !prev.keepMeUpdated,
                }))
              }
            />
            Keep me up to date with exclusive offers.
          </label>

          <button
            type="submit"
            disabled={formData.phoneNumber.length !== 10}
            className="mt-6 w-full rounded-full bg-[#0075ca] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#0063ad] disabled:cursor-not-allowed disabled:opacity-50 sm:text-base"
          >
            Send request
          </button>
        </form>
      </div>
    </section>
  );
}

export default RequestEstimate;
